import { AppPatient, WidgetSource } from '../components/app/types';

import { calculateSource } from '../hooks/useSourceConfig';

import { orderAssistLogger } from '../components/app/logger';
import { UserConfig } from '../hooks';
import { logic } from '../components/app/logic';
import { extractPatientSourceVaultToken } from '@getvim-core-apps/organizations';

export const isPatientEligibleForSource = (
  patient: AppPatient | undefined,
  source: WidgetSource | undefined,
): boolean => {
  return (
    !!source &&
    !!extractPatientSourceVaultToken(patient?.patientSourceVaultTokens, source)?.sourceVaultToken
  );
};

export const isPatientEligible = async (
  patient: AppPatient | undefined,
  userConfig: UserConfig | undefined,
): Promise<boolean> => {
  if (!patient) {
    orderAssistLogger.warning('Patient is not defined');
    return false;
  }
  if (!userConfig) {
    orderAssistLogger.warning('userConfig is undefined, cannot check eligibility for patient');
    return false;
  }

  const supportedPersonCapabilites = await logic.supportedPersonCapabilites(patient, userConfig);
  if (!supportedPersonCapabilites) {
    return false;
  }

  const source = calculateSource(patient, userConfig);
  return isPatientEligibleForSource(patient, source);
};
